import {
  ON_GET_AUTH_BOOKINGS,
  GET_AUTH_THIS_MONTH_BOOKING,
  GET_AUTH_CURRENT_BOOKING,
  GET_AUTH_UPCOMING_BOOKING,
  GET_AUTH_PREVIOUS_BOOKING,
  GET_AUTH_CANCELLED_BOOKING,
  GET_AUTH_BOOKING_ERROR,
  GET_AUTH_DETAIL_BOOKING,
} from "../actions/types";

const defaultBookingObject = {
  data: [],
  draw: 0,
  recordsFiltered: 0,
  recordsTotal: 0,
  hasMore: false
}

const initialState = {
  authThisMonthBookings: defaultBookingObject,
  authCurrentBookings: defaultBookingObject,
  authUpcomingBookings: defaultBookingObject,
  authPreviousBookings: defaultBookingObject,
  authCancelledBookings: defaultBookingObject,
  authDetailBooking: null,
  error: {},
  loading: false
};

export default function foo(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case ON_GET_AUTH_BOOKINGS:
      return {
        ...state,
        authThisMonthBookings: [],
        authCurrentBookings: [],
        authUpcomingBookings: [],
        authPreviousBookings: [],
        authCancelledBookings: [],
        authDetailBooking: null,
        loading: true,
      };
    case GET_AUTH_THIS_MONTH_BOOKING:
      return {
        ...state,
        authThisMonthBookings: payload,
        loading: false,
      };
    case GET_AUTH_CURRENT_BOOKING:
      return {
        ...state,
        authCurrentBookings: payload,
        loading: false,
      };
    case GET_AUTH_UPCOMING_BOOKING:
      return {
        ...state,
        authUpcomingBookings: payload,
        loading: false,
      };
    case GET_AUTH_PREVIOUS_BOOKING:
      return {
        ...state,
        authPreviousBookings: payload,
        loading: false,
      };
    case GET_AUTH_CANCELLED_BOOKING:
      return {
        ...state,
        authCancelledBookings: payload,
        loading: false,
      };
    case GET_AUTH_DETAIL_BOOKING:
      return {
        ...state,
        authDetailBooking: payload,
        loading: false
      };
    case GET_AUTH_BOOKING_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    default:
      return state;
  }
}